import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  userRequest: ["payload"],
  userSuccess: ["payload"], // payload: { userData }
  userFailure: ["payload"], // payload: { errors }

  getUserInfoByAdminRequest: ["payload"],
  getUserInfoByAdminSuccess: ["payload"],
  getUserInfoByAdminFailure: ["payload"],

  userSaveRequest: ["payload"], // payload: { data }
  userSaveSuccess: ["payload"], // payload: { saveResult }
  userSaveFailure: ["payload"], // payload: { errors }

  userSaveResultReset: null,

  userSaveAvatarRequest: ["payload"], // payload: { data }
  userSaveAvatarSuccess: ["payload"], // payload: { saveResult }
  userSaveAvatarFailure: ["payload"], // payload: { errors }

  changePasswordRequest: ["payload"], // payload: { data }
  changePasswordSuccess: ["payload"], // payload: { message }
  changePasswordFailure: ["payload"], // payload: { errors }

  sendCodePasswordRequest: ["payload"], // payload: { mail }
  sendCodePasswordSuccess: ["payload"], // payload: { saveResult }
  sendCodePasswordFailure: ["payload"], // payload: { errors }

  confirmCodePasswordRequest: ["payload"], // payload: { code }
  confirmCodePasswordSuccess: ["payload"], // payload: { saveResult }
  confirmCodePasswordFailure: ["payload"], // payload: { errors }

  createNewPasswordRequest: ["payload"], // payload: { new_password }
  createNewPasswordSuccess: ["payload"], // payload: { saveResult }
  createNewPasswordFailure: ["payload"], // payload: { errors }

  setPasswordRequest: ["payload"], // payload: { new_password }
  setPasswordSuccess: ["payload"], // payload: { saveResult }
  setPasswordFailure: ["payload"], // payload: { errors }

  changeEmailsRequest: ["payload"], // payload: { data }
  changeEmailsSuccess: ["payload"], // payload: { message }
  changeEmailsFailure: ["payload"], // payload: { errors }

  verifyEmailRequest: ["payload"], // payload: { data }
  verifyEmailSuccess: ["payload"], // payload: { message }
  verifyEmailFailure: ["payload"], // payload: { errors }

  confirmEmailsRequest: ["payload"], // payload: { hash }
  confirmEmailsSuccess: ["payload"], // payload: { message }
  confirmEmailsFailure: ["payload"], // payload: { errors }

  changeLanguageRequest: ["payload"],
  changeLanguageSuccess: ["payload"], // payload: { data }
  changeLanguageFailure: ["payload"], // payload: { errors }

  sendOnboardingFormRequest: ["payload"], // payload: { data }
  sendOnboardingFormSuccess: ["payload"], // payload: { saveResult }
  sendOnboardingFormFailure: ["payload"], // payload: { errors }

  createBusinessAccountRequest: ["payload"], // payload: { data }
  createBusinessAccountSuccess: ["payload"], // payload: { saveResult }
  createBusinessAccountFailure: ["payload"], // payload: { errors }

  updateBusinessAccountRequest: ["payload"], // payload: { data }
  updateBusinessAccountSuccess: ["payload"], // payload: { saveResult }
  updateBusinessAccountFailure: ["payload"], // payload: { errors }

  getBusinessAccountRequest: ["payload"], // payload: { id }
  getBusinessAccountSuccess: ["payload"], // payload: { saveResult }
  getBusinessAccountFailure: ["payload"], // payload: { errors }

  getAutoRefundLogsRequest: ["payload"],
  getAutoRefundLogsSuccess: ["payload"],
  getAutoRefundLogsFailure: ["payload"],
  getIntegrationLogsRequest: null,
  getIntegrationLogsSuccess: ['payload'],
  getIntegrationLogsFailure: ['payload'],

  getBusinessAccountsRequest: ['payload'],
  getBusinessAccountsSuccess: ["payload"], // payload: { saveResult }
  getBusinessAccountsFailure: ["payload"], // payload: { errors }

  getBusinessAccountsSettingsRequest: ['payload'], // payload: { page, page_size, user_id }
  getBusinessAccountsSettingsSuccess: ["payload"], // payload: { count, results }
  getBusinessAccountsSettingsFailure: ["payload"], // payload: { errors }

  getBusinessAccountsWithRoleRequest: null,
  getBusinessAccountsWithRoleSuccess: ["payload"], // payload: { businessAccountsWithRole }
  getBusinessAccountsWithRoleFailure: ["payload"], // payload: { errors }

  deleteBusinessAccountRequest: ["payload"],
  deleteBusinessAccountSuccess: ["payload"], // {deleteBusinessAccountId}
  deleteBusinessAccountFailure: ["payload"],

  skipPaymentConnectRequest: ["payload"], // payload: { businessAccountId }
  skipPaymentConnectSuccess: ["payload"], // payload: { saveResult }
  skipPaymentConnectFailure: ["payload"], // payload: { errors }

  getPaymentProcessorsRequest: ["payload"], // payload: { data }
  getPaymentProcessorsSuccess: ["payload"], // payload: { saveResult }
  getPaymentProcessorsFailure: ["payload"], // payload: { errors }

  connectPaymentProcessorRequest: ["payload"], // payload: { data }
  connectPaymentProcessorSuccess: ["payload"], // payload: { saveResult }
  connectPaymentProcessorFailure: ["payload"], // payload: { errors }

  adyenUploadFilesRequest: ["payload"], // payload: { data }
  adyenUploadFilesSuccess: ["payload"], // payload: { saveResult }
  adyenUploadFilesFailure: ["payload"], // payload: { errors }

  disconnectPaymentProcessorRequest: ["payload"], // payload: { data }
  disconnectPaymentProcessorSuccess: ["payload"], // payload: { saveResult }
  disconnectPaymentProcessorFailure: ["payload"], // payload: { errors }

  disconnectPaymentProcessorExternallyRequest: ["payload"], // payload: { data }
  disconnectPaymentProcessorExternallySuccess: ["payload"], // payload: { saveResult }
  disconnectPaymentProcessorExternallyFailure: ["payload"], // payload: { errors }

  createBillingDescriptorRequest: ["payload"], // payload: { data }
  createBillingDescriptorSuccess: ["payload"], // payload: { saveResult }
  createBillingDescriptorFailure: ["payload"], // payload: { errors }

  validateBillingDescriptorRequest: ["payload"],
  validateBillingDescriptorSuccess: ["payload"],
  validateBillingDescriptorFailure: ["payload"],
  validateBillingDescriptorReset: null,

  updateBillingDescriptorStatusRequest: ["payload"], // payload: { data }
  updateBillingDescriptorStatusSuccess: ["payload"], // payload: { saveResult }
  updateBillingDescriptorStatusFailure: ["payload"], // payload: { errors }

  getBillingDescriptorsRequest: ["payload"], // payload: { data }
  getBillingDescriptorsSuccess: ["payload"], // payload: { billingDescriptors }
  getBillingDescriptorsFailure: ["payload"], // payload: { errors }

  getUsersCardsRequest: ["payload"], // payload: { data }
  getUsersCardsSuccess: ["payload"], // payload: { cards }
  getUsersCardsFailure: ["payload"], // payload: { errors }

  deleteUserCardRequest: ["payload"], // payload: { data }
  deleteUserCardSuccess: ["payload"], // payload: { cards }
  deleteUserCardFailure: ["payload"], // payload: { errors }

  updateDefaultCardRequest: ["payload"], // payload: { data }
  updateDefaultCardSuccess: ["payload"], // payload: { cards }
  updateDefaultCardFailure: ["payload"], // payload: { errors }

  createCheckoutSessionRequest: ["payload"], // payload: { payment_service_business_account_id }
  createCheckoutSessionSuccess: ["payload"], // payload: { checkoutSession }
  createCheckoutSessionFailure: ["payload"], // payload: { errors }

  attachPaymentRequest: ["payload"], // payload: { data }
  attachPaymentSuccess: ["payload"], // payload: { checkoutSession }
  attachPaymentFailure: ["payload"], // payload: { errors }

  getPremiumFeaturesRequest: ["payload"], // payload: { data }
  getPremiumFeaturesSuccess: ["payload"], // payload: { premiumFeatures }
  getPremiumFeaturesFailure: ["payload"], // payload: { errors }

  getEnrollmentsRequest: ["payload"], // payload: { data }
  getEnrollmentsSuccess: ["payload"], // payload: { saveResult }
  getEnrollmentsFailure: ["payload"], // payload: { errors }

  getAdminEnrollmentsRequest: ['payload'],
  getAdminEnrollmentsSuccess: ['payload'],
  getAdminEnrollmentsFailure: ['payload'],

  getEnrollmentsWithoutDescriptorsRequest: ["payload"], // payload: { data }
  getEnrollmentsWithoutDescriptorsSuccess: ["payload"], // payload: { saveResult }
  getEnrollmentsWithoutDescriptorsFailure: ["payload"], // payload: { errors }

  getDescriptorsByEnrollmentRequest: ["payload"],
  getDescriptorsByEnrollmentSuccess: ["payload"],
  getDescriptorsByEnrollmentFailure: ["payload"],

  getMoreDescriptorsByEnrollmentRequest: ["payload"],
  getMoreDescriptorsByEnrollmentSuccess: ["payload"],
  getMoreDescriptorsByEnrollmentFailure: ["payload"],

  getVisaCodesByEnrollmentRequest: ['payload'],
  getVisaCodesByEnrollmentSuccess: ['payload'],
  getVisaCodesByEnrollmentFailure: ['payload'],

  getMoreVisaCodesByEnrollmentRequest: ['payload'],
  getMoreVisaCodesByEnrollmentSuccess: ['payload'],
  getMoreVisaCodesByEnrollmentFailure: ['payload'],

  getAdminDescriptorsByEnrollmentRequest: ['payload'],
  getAdminDescriptorsByEnrollmentSuccess: ['payload'],
  getAdminDescriptorsByEnrollmentFailure: ['payload'],

  getMoreAdminDescriptorsByEnrollmentRequest: ['payload'],
  getMoreAdminDescriptorsByEnrollmentSuccess: ['payload'],
  getMoreAdminDescriptorsByEnrollmentFailure: ['payload'],

  updateAdminDescriptorStatusRequest: ['payload'],
  updateAdminDescriptorStatusSuccess: ['payload'],
  updateAdminDescriptorStatusFailure: ['payload'],

  updateAdminDescriptorTypeRequest: ['payload'],
  updateAdminDescriptorTypeSuccess: ['payload'],
  updateAdminDescriptorTypeFailure: ['payload'],

  bulkUpdateAdminDescriptorStatusRequest: ["payload"],
  bulkUpdateAdminDescriptorStatusSuccess: ["payload"],
  bulkUpdateAdminDescriptorStatusFailure: ["payload"],

  updateEnrollmentRequest: ["payload"], // payload: { data }
  updateEnrollmentSuccess: ["payload"], // payload: { saveResult }
  updateEnrollmentFailure: ["payload"], // payload: { errors }

  changeStatusEnrollmentRequest: ["payload"], // payload: { data }
  changeStatusEnrollmentSuccess: ["payload"], // payload: { enrollment }
  changeStatusEnrollmentFailure: ["payload"], // payload: { errors }

  changeOnboardingStepRequest: ["payload"], // payload: { data }
  changeOnboardingStepSuccess: ["payload"], // payload: { saveResult }
  changeOnboardingStepFailure: ["payload"], // payload: { errors }

  requestNewIntegrationRequest: ["payload"], // payload: { data }
  requestNewIntegrationSuccess: ["payload"], // payload: { saveResult }
  requestNewIntegrationFailure: ["payload"], // payload: { errors }

  declinePremiumFeaturesRequest: null,
  declinePremiumFeaturesSuccess: ["payload"], // payload: { saveResult }
  declinePremiumFeaturesFailure: ["payload"], // payload: { errors }

  updateUserPriceRequest: ["payload"], // payload: { data }
  updateUserPriceSuccess: ["payload"], // payload: { businessAccount }
  updateUserPriceFailure: ["payload"], // payload: { errors }

  trackEventRequest: ["payload"],
  trackEventSuccess: ["payload"],
  trackEventFailure: ["payload"],

  getMaxCreateStepsRequest: null,
  getMaxCreateStepsSuccess: ["payload"],
  getMaxCreateStepsFailure: ["payload"],

  setVerifyLastReqTime: ["payload"],
  userErrorsReset: null,

  changeNextCreateAccountStep: ["nextCreateAccountStep"],
  userSetProp: ["key", "value"],
  setDemoTourStep: ["payload"],

  getBannerInfoRequest: null,
  getBannerInfoSuccess: ["payload"], // payload: { balance, days_counter }
  getBannerInfoFailure: ["payload"], // payload: { errors }

  getBusinessInfoRequest: ["payload"],
  getBusinessInfoSuccess: ["payload"],
  getBusinessInfoFailure: ["payload"],

  changeEmailOnboardingRequest: ["payload"], // payload: { data }
  changeEmailOnboardingSuccess: ["payload"], // payload: { message }
  changeEmailOnboardingFailure: ["payload"], // payload: { errors }
  checkMaverickDbaRequest: ["payload"], // { merchant_id, dba_id }
  checkMaverickDbaSuccess: ["payload"], // response
  checkMaverickDbaFailure: ["payload"], // { errors }
  checkMaverickDbaReset: null,

  connectMaverickTerminalsRequest: ["payload"],
  connectMaverickTerminalsSuccess: ["payload"],
  connectMaverickTerminalsFailure: ["payload"],
  connectMaverickTerminalsReset: null,

  demoDataToggleRequest: ["payload"], // payload: { isShown }
  demoDataToggleSuccess: ["payload"],
  demoDataToggleFailure: null,

  changeBusinessAccountRequest: ["payload"],
  changeBusinessAccountSuccess: ["payload"],
  changeBusinessAccountFailure: ["payload"],

  logout: null
})

export const UserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  errors: false,

  saveResult: null,
  saveFetching: false,
  businessAccountSwitching: false,

  businessAccountsWithRoleFetching: false,
  businessAccountsWithRole: [],

  businessAccountsFetching: false,
  businessAccounts: [],

  businessAccountsSettingsFetching: false,
  businessAccountsSettings: [],
  businessAccountsSettingsCount: 0,

  businessAccountFetching: false,
  businessAccount: null,
  autoRefundLogsFetching: false,
  autoRefundLogs: [],
  integrationLogsFetching: false,
  integrationLogs: [],

  isOneProcessorConnected: false,
  isManualRefundsConnected: false,
  paymentProcessors: [],
  enrollments: [],
  adminEnrollments: [],
  adminEnrollmentsFetching: false,
  userEnrollments: [],
  userEnrollmentsBusinessAccountId: null,
  userEnrollmentsFetching: false,
  userEnrollmentsError: null,
  descriptorsByEnrollment: null,
  descriptorsByEnrollmentFetching: false,
  moreDescriptorsByEnrollmentFetching: false,
  descriptorsByEnrollmentError: null,
  visaCodesByEnrollment: null,
  visaCodesByEnrollmentFetching: false,
  moreVisaCodesByEnrollmentFetching: false,
  visaCodesByEnrollmentError: null,
  adminDescriptorsByEnrollment: null,
  adminDescriptorsByEnrollmentFetching: false,
  moreAdminDescriptorsByEnrollmentFetching: false,
  adminDescriptorsByEnrollmentError: null,
  adminDescriptorStatusUpdating: false,
  adminDescriptorTypeUpdating: false,
  enrollmentsFetching: false,
  billingDescriptors: {
    descriptor_data: [],
    dont_remember_descriptors: false,
    dont_remember_arn_codes: false
  },
  usersCards: [],
  checkoutSession: null,
  errorDescriptors: [],
  errorBinCodes: [],
  errorCaidCodes: [],
  validateBillingDescriptorResult: null,

  nextCreateAccountStep: null,
  redirectAfterCreateAccount: null,
  nextManageEnrollmentStep: null,

  maxCreateStepsFetching: false,
  maxCreateSteps: 6,

  bannerInfo: null,
  bannerInfoFetching: true,

  businessInfo: null,

  premiumFeatures: [],

  saveAvatarFetching: false,
  verifyLastReqTime: null,
  demoTourStep: null,

  trackEventfetching: false,
  userInfoForAdmin: null,
  emailChanged: false,

  adyenFilesUploading: false,

  maverickDba: null,
  maverickDbaFetching: false,
  maverickDbaError: null,

  maverickConnect: null,
  maverickConnectFetching: false,
  maverickConnectError: null,

  demoDataShownToggleLoading: false
})

/* ------------- Selectors ------------- */
export const UserSelectors = {
  getUser: (state) => state.user,
  getNextCreateAccountStep: (state) => state.user.nextCreateAccountStep,
  getNextManageEnrollmentStep: (state) => state.user.nextManageEnrollmentStep,
  getRedirectAfterCreateAccount: (state) => state.user.redirectAfterCreateAccount,
  getEnrollmentInfo: (state, ...args) => state.user.enrollments?.find((el) => el.id === args[0]),
  getMaxCreateSteps: (state) => state.user.maxCreateSteps
}

/* ------------- Reducers ------------- */

//GET USER DATA
const setVerifyLastReqTime = (state, { payload: time }) => state.merge({ verifyLastReqTime: time })

const userRequest = (state) => {
  return state.merge({ fetching: true })
}
const userSuccess = (state, { payload: userInfo }) => {
  // return state.merge({
  //   fetching: false,
  //   userInfo: { ...state.userInfo, ...userInfo },
  // });
  return state.merge({ fetching: false })
}
const userFailure = (state, { payload: errors }) => state.merge({ fetching: false, errors })

const getUserInfoByAdminRequest = (state, { payload: data }) => {
  return state.merge({ fetching: true })
}
const getUserInfoByAdminSuccess = (state, { payload: data }) => {
  return state.merge({ fetching: false, userInfoForAdmin: data })
}
const getUserInfoByAdminFailure = (state, { payload: errors }) =>
  state.merge({ fetching: false, errors })

// CHANGE USER DATA
const userSaveRequest = (state, { payload: data }) => {
  return state.merge({ saveFetching: true })
}
const userSaveSuccess = (state, { payload: data }) => {
  if (data?.user_id) {
    return state.merge({ saveFetching: false, saveResult: true, userInfoForAdmin: data?.data })
  } else {
    return state.merge({ saveFetching: false, saveResult: true })
  }
}

const userSaveFailure = (state, { payload: errors }) => {
  return state.merge({
    saveAvatarFetching: false,
    errors: { userPersonalError: errors },
    saveFetching: false
  })
}

// RESET ERRORS
const userSaveResultReset = (state, { payload: saveResult }) => {
  return state.merge({ saveFetching: false, saveResult: null })
}
const userErrorsReset = (state) => {
  return state.merge({ errors: false })
}

// CHANGE USER AVATAR
const userSaveAvatarRequest = (state, { payload: data }) => {
  return state.merge({ saveAvatarFetching: true })
}

const userSaveAvatarSuccess = (state, { payload: result }) => {
  let saveResult = result.avatar ? { avatar: "removed" } : { avatar: "delete" }

  return state.merge({ saveAvatarFetching: false, saveResult })
}
const userSaveAvatarFailure = (state, { payload: { errors } }) => {
  return state.merge({ saveAvatarFetching: false, errors: { avatarError: errors } })
}

// CHANGE PASSWORD
const changePasswordRequest = (state) => state.merge({ saveFetching: true })

const changePasswordSuccess = (state, { payload }) =>
  state.merge({ saveFetching: false, saveResult: { create: true } })

const changePasswordFailure = (state, { payload: { errors } }) =>
  state.merge({ saveFetching: false, errors })

// SEND CODE TO MAIL FOR CHANGE PASSWORD
const sendCodePasswordRequest = (state, { payload: email }) => {
  return state.merge({ saveFetching: true })
}
const sendCodePasswordSuccess = (state, { payload }) => {
  return state.merge({ saveFetching: false, saveResult: true })
}
const sendCodePasswordFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, saveFetching: false, errors })

// CONFIRM CODE FROM MAIL TO CHANGE PASSWORD
const confirmCodePasswordRequest = (state, { payload }) => {
  return state.merge({ saveFetching: true })
}
const confirmCodePasswordSuccess = (state, { payload }) => {
  return state.merge({ saveFetching: false, saveResult: { confirm: true } })
}
const confirmCodePasswordFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, saveFetching: false, errors })

// CREATE NEW PASSWORD
const createNewPasswordRequest = (state, { payload }) => {
  return state.merge({ saveFetching: true })
}
const createNewPasswordSuccess = (state, { payload }) => {
  return state.merge({ saveFetching: false, saveResult: { create: true } })
}
const createNewPasswordFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, saveFetching: false, errors })

// SET PASSWORD
const setPasswordRequest = (state, { payload }) => {
  return state.merge({ saveFetching: true })
}
const setPasswordSuccess = (state, { payload }) => {
  return state.merge({
    saveFetching: false,
    saveResult: { setPassword: true }
  })
}
const setPasswordFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, saveFetching: false, errors })

// CHANGE EMAIL
const changeEmailsRequest = (state) => state.merge({ saveFetching: true })

const changeEmailsSuccess = (state, { payload }) =>
  state.merge({ saveFetching: false, saveResult: { confirm: true } })

const changeEmailsFailure = (state, { payload: { errors } }) =>
  state.merge({ saveFetching: false, errors })

const verifyEmailRequest = (state) => state.merge({ saveFetching: true })

const verifyEmailSuccess = (state, { payload }) =>
  state.merge({ saveFetching: false, saveResult: { confirm: true } })

const verifyEmailFailure = (state, { payload: { errors } }) =>
  state.merge({ saveFetching: false, errors })

//CONFIRM EMAIL

const confirmEmailsRequest = (state) => state.merge({ saveFetching: true })

const confirmEmailsSuccess = (state, { payload }) =>
  state.merge({ saveFetching: false, saveResult: { confirmEmail: true } })

const confirmEmailsFailure = (state, { payload: { errors } }) =>
  state.merge({
    saveFetching: false,
    errors: { confirmError: errors }
  })

// CHANGE LANGUAGE

const changeLanguageRequest = (state, { lang }) => state.merge({ saveFetching: true })

const changeLanguageSuccess = (state, { payload }) =>
  state.merge({ saveFetching: false, saveResult: { changeLanguage: true } })
const changeLanguageFailure = (state, { payload: { errors } }) =>
  state.merge({ saveFetching: false, errors })

const sendOnboardingFormRequest = (state) => state.merge({ saveFetching: true })
const sendOnboardingFormSuccess = (state) => state.merge({ saveFetching: false })
const sendOnboardingFormFailure = (state) => state.merge({ saveFetching: false })

// CREATE BUSINESS ACCOUNT
const createBusinessAccountRequest = (state) => {
  return state.merge({ businessAccountsFetching: true })
}
const createBusinessAccountSuccess = (state, { payload: businessAccount }) => {
  let businessAccounts = state.businessAccounts.length ? state.businessAccounts : [businessAccount]
  return state.merge({
    businessAccountsFetching: false,
    businessAccounts,
    businessAccount
  })
}
const createBusinessAccountFailure = (state, { payload: { errors } }) =>
  state.merge({ businessAccountsFetching: false, errors })

// CHANGE BUSINESS ACCOUNT DATA
const updateBusinessAccountRequest = (state, { payload: data }) => {
  return state.merge({ saveFetching: true })
}
const updateBusinessAccountSuccess = (state, { payload: businessAccount }) => {
  if (businessAccount?.settings_for_auto_refund || businessAccount?.name) {
    const newBusinessAccount = state.businessAccounts.map((ba) =>
      ba.id === businessAccount.id ? { ...ba, ...businessAccount } : ba
    )
    const newBusinessAccountsSettings = state.businessAccountsSettings.map((ba) =>
      ba.id === businessAccount.id ? { ...ba, ...businessAccount } : ba
    )

    return state.merge({
      saveFetching: false,
      saveResult: true,
      businessAccount: { ...state.businessAccount, ...businessAccount },
      businessAccounts: newBusinessAccount,
      businessAccountsSettings: newBusinessAccountsSettings
    })
  } else {
    return state.merge({
      saveFetching: false,
      saveResult: true,
      businessAccount: {
        ...state.businessAccount,
        settings_for_auto_refund: { ...businessAccount }
      }
    })
  }
}
const updateBusinessAccountFailure = (state, { payload: errors }) => {
  return state.merge({
    saveAvatarFetching: false,
    saveFetching: false,
    errors: { businessAccountError: errors }
  })
}

const getBusinessAccountRequest = (state) => {
  return state.merge({ businessAccountFetching: true, businessAccount: null })
}
const getBusinessAccountSuccess = (state, { payload: businessAccount }) => {
  return state.merge({ businessAccountFetching: false, businessAccount })
}
const getBusinessAccountFailure = (state) => state.merge({ businessAccountFetching: false })

const getAutoRefundLogsRequest = (state) => state.merge({ autoRefundLogsFetching: true })
const getAutoRefundLogsSuccess = (state, { payload }) =>
  state.merge({ autoRefundLogsFetching: false, autoRefundLogs: payload?.results || payload || [] })
const getAutoRefundLogsFailure = (state) => state.merge({ autoRefundLogsFetching: false })

const getIntegrationLogsRequest = (state) =>
  state.merge({integrationLogsFetching: true})
const getIntegrationLogsSuccess = (state, {payload}) =>
  state.merge({integrationLogsFetching: false, integrationLogs: payload?.results || payload || []})
const getIntegrationLogsFailure = (state) =>
  state.merge({integrationLogsFetching: false})

const deleteBusinessAccountRequest = (state) => {
  return state.merge({ businessAccountFetching: true })
}
const deleteBusinessAccountSuccess = (state) => {
  return state.merge({
    businessAccountFetching: false,
    nextCreateAccountStep: null,
    businessAccount: null,
    autoRefundLogs: [],
    paymentProcessors: [],
    enrollments: [],
    billingDescriptors: {
      descriptor_data: [],
      dont_remember_descriptors: false,
      dont_remember_arn_codes: false
    },
    checkoutSession: null
  })
}
const deleteBusinessAccountFailure = (state) => state.merge({ businessAccountFetching: false })

const getBusinessAccountsRequest = (state) =>
  state.merge({ businessAccountsFetching: true, businessAccounts: [] })
const getBusinessAccountsSuccess = (state, { payload }) =>
  state.merge({ businessAccountsFetching: false, businessAccounts: [...payload?.results] })
const getBusinessAccountsFailure = (state) => state.merge({ businessAccountsFetching: false })

const getBusinessAccountsSettingsRequest = (state) =>
  state.merge({ businessAccountsSettingsFetching: true })
const getBusinessAccountsSettingsSuccess = (state, { payload }) =>
  state.merge({
    businessAccountsSettingsFetching: false,
    businessAccountsSettings: [...(payload?.results || [])],
    businessAccountsSettingsCount: payload?.count || 0
  })
const getBusinessAccountsSettingsFailure = (state) =>
  state.merge({ businessAccountsSettingsFetching: false })

const getBusinessAccountsWithRoleRequest = (state) =>
  state.merge({ businessAccountsWithRoleFetching: true })
const getBusinessAccountsWithRoleSuccess = (state, { payload: businessAccountsWithRole }) =>
  state.merge({ businessAccountsWithRoleFetching: false, businessAccountsWithRole })
const getBusinessAccountsWithRoleFailure = (state) =>
  state.merge({ businessAccountsWithRoleFetching: false })

const skipPaymentConnectRequest = (state) => state.merge({ businessAccountFetching: true })
const skipPaymentConnectSuccess = (state, { payload: businessAccount }) => {
  let newBusinessAccounts = null
  if (state.businessAccounts.length === 1) {
    newBusinessAccounts = [businessAccount]
  } else {
    newBusinessAccounts = [...state.businessAccounts].map((el) =>
      el.id === businessAccount.id ? businessAccount : el
    )
  }
  return state.merge({
    businessAccountFetching: false,
    businessAccount,
    businessAccounts: newBusinessAccounts
  })
}
const skipPaymentConnectFailure = (state) => state.merge({ businessAccountFetching: false })

const getPaymentProcessorsRequest = (state) => state.merge({ fetching: true })
const getPaymentProcessorsSuccess = (state, { payload }) => {
  let isOneProcessorConnected = payload?.results.some((el) => el.is_connected === true)
  let isManualRefundsConnected = payload?.results?.find(
    (el) => el.service_name === "manual_refunds"
  )?.["is_connected"]
  return state.merge({
    fetching: false,
    paymentProcessors: [...payload?.results],
    isOneProcessorConnected,
    isManualRefundsConnected
  })
}
const getPaymentProcessorsFailure = (state) => state.merge({ fetching: false })

const connectPaymentProcessorRequest = (state) =>
  state.merge({
    businessAccountFetching: true,
    saveFetching: true
  })
const connectPaymentProcessorSuccess = (state, { payload: paymentProcessor }) => {
  let newPaymentProcessors = [...state.paymentProcessors].map((el) => ({
    ...el,
    is_connected:
      (el.service_name === "manual_refunds" ? false : el?.is_connected) ||
      el?.id === paymentProcessor?.id
  }))
  let isManualRefundsConnected = newPaymentProcessors?.find(
    (el) => el.service_name === "manual_refunds"
  )?.["is_connected"]
  return state.merge({
    businessAccountFetching: false,
    isOneProcessorConnected: true,
    isManualRefundsConnected,
    paymentProcessors: [...newPaymentProcessors],
    saveResult: "connected",
    saveFetching: false
  })
}
const connectPaymentProcessorFailure = (state, { payload: connect_error }) =>
  state.merge({
    businessAccountFetching: false,
    saveFetching: false,
    saveResult: { connect_error }
  })

const adyenUploadFilesRequest = (state) => state.merge({ adyenFilesUploading: true })
const adyenUploadFilesSuccess = (state, { payload: saveResult }) =>
  state.merge({ adyenFilesUploading: false })
const adyenUploadFilesFailure = (state, { payload: errors }) =>
  state.merge({ adyenFilesUploading: false })

const disconnectPaymentProcessorRequest = (state) =>
  state.merge({
    businessAccountFetching: true,
    saveFetching: true
  })
const disconnectPaymentProcessorSuccess = (state, { payload: paymentProcessor }) => {
  let newPaymentProcessors = [...state.paymentProcessors]
    ?.filter(
      ({ id }) =>
        !(
          ["slack", "premium_support", "full"].includes(paymentProcessor?.id) &&
          id === paymentProcessor?.id
        )
    )
    ?.map((el) => ({
      ...el,
      is_connected: el?.id === paymentProcessor?.id ? false : el?.is_connected,
      connected_account: el?.id === paymentProcessor?.id ? null : el?.connected_account
    }))
  let isOneProcessorConnected = newPaymentProcessors.some((el) => el.is_connected)
  let isManualRefundsConnected = newPaymentProcessors?.find(
    (el) => el.service_name === "manual_refunds"
  )?.["is_connected"]

  return state.merge({
    businessAccountFetching: false,
    isOneProcessorConnected,
    isManualRefundsConnected,
    paymentProcessors: [...newPaymentProcessors],
    saveResult: "disconnected",
    saveFetching: false
  })
}
const disconnectPaymentProcessorFailure = (state) =>
  state.merge({ businessAccountFetching: false, saveFetching: false })

const disconnectPaymentProcessorExternallyRequest = (state) =>
  state.merge({ businessAccountFetching: true, saveFetching: true })
const disconnectPaymentProcessorExternallySuccess = (state) =>
  state.merge({ businessAccountFetching: false, saveFetching: false, saveResult: "disconnected" })
const disconnectPaymentProcessorExternallyFailure = (state) =>
  state.merge({ businessAccountFetching: false, saveFetching: false })

const createBillingDescriptorRequest = (state) => state.merge({ fetching: true })
const createBillingDescriptorSuccess = (state, { payload: billingDescriptors }) => {
  return state.merge({
    fetching: false,
    billingDescriptors,
    nextCreateAccountStep: state.nextCreateAccountStep
      ? state.nextCreateAccountStep === 4
        ? 5
        : state.nextCreateAccountStep
      : null,
    errorDescriptors: [],
    errorBinCodes: [],
    errorCaidCodes: []
  })
}
const createBillingDescriptorFailure = (state, { payload: errors }) => {
  return state.merge({
    fetching: false,
    errorDescriptors: errors && errors?.descriptors ? [...errors?.descriptors] : [],
    errorBinCodes: errors && errors?.bin_codes ? [...errors?.bin_codes] : [],
    errorCaidCodes: errors && errors?.caid_codes ? [...errors?.caid_codes] : []
  })
}

const validateBillingDescriptorRequest = (state) =>
  state.merge({
    fetching: true,
    validateBillingDescriptorResult: null
  })

const validateBillingDescriptorSuccess = (state, { payload }) =>
  state.merge({
    fetching: false,
    validateBillingDescriptorResult: payload,
    errorDescriptors: [],
    errorBinCodes: [],
    errorCaidCodes: []
  })

const validateBillingDescriptorFailure = (state, { payload: errors }) =>
  state.merge({
    fetching: false,
    validateBillingDescriptorResult: null,
    errorDescriptors: errors && errors?.descriptors ? [...errors?.descriptors] : [],
    errorBinCodes: errors && errors?.bin_codes ? [...errors?.bin_codes] : [],
    errorCaidCodes: errors && errors?.caid_codes ? [...errors?.caid_codes] : []
  })

const validateBillingDescriptorReset = (state) =>
  state.merge({
    validateBillingDescriptorResult: null,
    errorDescriptors: [],
    errorBinCodes: [],
    errorCaidCodes: []
  })

const updateBillingDescriptorStatusRequest = (state) => state.merge({ saveFetching: true })
const updateBillingDescriptorStatusSuccess = (state, { payload: billingDescriptor }) =>
  state.merge({
    saveFetching: false,
    saveResult: "descriptor_status_changed"
  })
const updateBillingDescriptorStatusFailure = (state) => state.merge({ saveFetching: false })

const getBillingDescriptorsRequest = (state) => state.merge({ fetching: true })
const getBillingDescriptorsSuccess = (state, { payload: billingDescriptors }) => {
  return state.merge({
    fetching: false,
    billingDescriptors: billingDescriptors
  })
}
const getBillingDescriptorsFailure = (state) => state.merge({ fetching: false })

const getUsersCardsRequest = (state) => state.merge({ fetching: true })
const getUsersCardsSuccess = (state, { payload: usersCards }) => {
  return state.merge({
    fetching: false,
    usersCards: usersCards.results
  })
}
const getUsersCardsFailure = (state) => state.merge({ fetching: false })

const deleteUserCardRequest = (state) => state.merge({ fetching: true })
const deleteUserCardSuccess = (state, { payload }) => {
  const deletedCardId = payload?.card_id ?? payload?.id?.card_id ?? payload?.id

  return state.merge({
    fetching: false,
    usersCards: state.usersCards.filter((card) => card.id !== deletedCardId)
  })
}
const deleteUserCardFailure = (state) => state.merge({ fetching: false })

const updateDefaultCardRequest = (state) => state.merge({ fetching: true })
const updateDefaultCardSuccess = (state, { payload: card }) => {
  const { id } = card
  const oldCard = state.usersCards.find((card) => card.is_default)
  return state.merge({
    fetching: false,
    usersCards: state.usersCards.map((card) => {
      if (card.id === oldCard?.id) {
        return { ...card, is_default: false }
      }
      if (card.id === id) {
        return { ...card, is_default: true }
      }
      return card
    })
  })
}
const updateDefaultCardFailure = (state) => state.merge({ fetching: false })

const createCheckoutSessionRequest = (state) => state.merge({ fetching: true })
const createCheckoutSessionSuccess = (state, { payload: checkoutSession }) =>
  state.merge({ fetching: false, checkoutSession })
const createCheckoutSessionFailure = (state) => state.merge({ fetching: false })

const attachPaymentRequest = (state) => {
  return state.merge({ fetching: true })
}
const attachPaymentSuccess = (state) =>
  state.merge({
    fetching: false,
    checkoutSession: null,
    nextCreateAccountStep: 8,
    redirectAfterCreateAccount: null,
    businessAccount: null,
    // saveResult: 'business_created',
    saveResult: null
  })

const attachPaymentFailure = (state) => state.merge({ fetching: false })

const getPremiumFeaturesRequest = (state) => state.merge({ fetching: true })
const getPremiumFeaturesSuccess = (state, { payload: premiumFeatures }) => {
  return state.merge({
    fetching: false,
    premiumFeatures
  })
}
const getPremiumFeaturesFailure = (state) => state.merge({ fetching: false })

const getEnrollmentsRequest = (state) => state.merge({ fetching: true, enrollmentsFetching: true })
const getEnrollmentsSuccess = (state, { payload }) => {
  let results = [...payload?.results]
  return state.merge({
    fetching: false,
    enrollments: results,
    enrollmentsFetching: false
  })
}
const getEnrollmentsFailure = (state) =>
  state.merge({ fetching: false, enrollmentsFetching: false })

const getAdminEnrollmentsRequest = (state) =>
  state.merge({adminEnrollmentsFetching: true, adminEnrollments: []})
const getAdminEnrollmentsSuccess = (state, {payload}) => {
  const results = payload?.results || payload || []
  return state.merge({
    adminEnrollmentsFetching: false,
    adminEnrollments: Array.isArray(results) ? results : [],
  })
}
const getAdminEnrollmentsFailure = (state) =>
  state.merge({adminEnrollmentsFetching: false})

const getEnrollmentsWithoutDescriptorsRequest = (state, { payload: businessAccountId }) =>
  state.merge({
    userEnrollmentsFetching: true,
    userEnrollmentsBusinessAccountId: businessAccountId,
    userEnrollments: [],
    descriptorsByEnrollment: null,
    visaCodesByEnrollment: null,
  })
const getEnrollmentsWithoutDescriptorsSuccess = (state, { payload }) => {
  return state.merge({
    userEnrollmentsFetching: false,
    userEnrollments: payload
  })
}
const getEnrollmentsWithoutDescriptorsFailure = (state) =>
  state.merge({ userEnrollmentsFetching: false })

const getDescriptorsByEnrollmentRequest = (state) =>
  state.merge({ descriptorsByEnrollmentFetching: true })
const getDescriptorsByEnrollmentSuccess = (state, { payload }) => {
  return state.merge({
    descriptorsByEnrollmentFetching: false,
    descriptorsByEnrollment: payload
  })
}
const getDescriptorsByEnrollmentFailure = (state) =>
  state.merge({ descriptorsByEnrollmentFetching: false })

const getMoreDescriptorsByEnrollmentRequest = (state) =>
  state.merge({ moreDescriptorsByEnrollmentFetching: true })
const getMoreDescriptorsByEnrollmentSuccess = (state, { payload }) => {
  return state.merge({
    moreDescriptorsByEnrollmentFetching: false,
    descriptorsByEnrollment: {
      ...payload,
      results: [...state.descriptorsByEnrollment?.results, ...payload?.results]
    }
  })
}
const getMoreDescriptorsByEnrollmentFailure = (state) =>
  state.merge({ moreDescriptorsByEnrollmentFetching: false })

const getVisaCodesByEnrollmentRequest = (state) =>
  state.merge({visaCodesByEnrollmentFetching: true})
const getVisaCodesByEnrollmentSuccess = (state, {payload}) => {
  return state.merge({
    visaCodesByEnrollmentFetching: false,
    visaCodesByEnrollment: payload,
  })
}
const getVisaCodesByEnrollmentFailure = (state) =>
  state.merge({visaCodesByEnrollmentFetching: false})

const getMoreVisaCodesByEnrollmentRequest = (state) =>
  state.merge({moreVisaCodesByEnrollmentFetching: true})
const getMoreVisaCodesByEnrollmentSuccess = (state, {payload}) => {
  return state.merge({
    moreVisaCodesByEnrollmentFetching: false,
    visaCodesByEnrollment: {
      ...payload,
      results: [
        ...(state.visaCodesByEnrollment?.results || []),
        ...(payload?.results || []),
      ],
    },
  })
}

const getAdminDescriptorsByEnrollmentRequest = (state) =>
  state.merge({adminDescriptorsByEnrollmentFetching: true})

const getAdminDescriptorsByEnrollmentSuccess = (state, {payload}) => {
  return state.merge({
    adminDescriptorsByEnrollmentFetching: false,
    adminDescriptorsByEnrollment: payload,
  })
}

const getAdminDescriptorsByEnrollmentFailure = (state) =>
  state.merge({adminDescriptorsByEnrollmentFetching: false})

const getMoreAdminDescriptorsByEnrollmentRequest = (state) =>
  state.merge({moreAdminDescriptorsByEnrollmentFetching: true})
const getMoreAdminDescriptorsByEnrollmentSuccess = (state, {payload}) => {
  return state.merge({
    moreAdminDescriptorsByEnrollmentFetching: false,
    adminDescriptorsByEnrollment: {
      ...payload,
      results: [
        ...(state.adminDescriptorsByEnrollment?.results || []),
        ...(payload?.results || []),
      ],
    },
  })
}
const getMoreVisaCodesByEnrollmentFailure = (state) =>
  state.merge({moreVisaCodesByEnrollmentFetching: false})

const getMoreAdminDescriptorsByEnrollmentFailure = (state) =>
  state.merge({moreAdminDescriptorsByEnrollmentFetching: false})

const updateAdminDescriptorStatusRequest = (state) =>
  state.merge({adminDescriptorStatusUpdating: true})
const updateAdminDescriptorStatusSuccess = (state, {payload}) => {
  const updatedId = payload?.billing_descriptor_id
  const nextResults = (state.adminDescriptorsByEnrollment?.results || []).map((item) =>
    item?.billing_descriptor_id === updatedId
      ? {
          ...item,
          current_status: payload?.status ?? item?.current_status,
        }
      : item,
  )

  return state.merge({
    adminDescriptorStatusUpdating: false,
    adminDescriptorsByEnrollment: state.adminDescriptorsByEnrollment
      ? {
          ...state.adminDescriptorsByEnrollment,
          results: nextResults,
        }
      : state.adminDescriptorsByEnrollment,
  })
}
const updateAdminDescriptorStatusFailure = (state) =>
  state.merge({adminDescriptorStatusUpdating: false})

const updateAdminDescriptorTypeRequest = (state) =>
  state.merge({adminDescriptorTypeUpdating: true})
const updateAdminDescriptorTypeSuccess = (state, {payload}) => {
  const updatedId = payload?.billing_descriptor_id
  const nextResults = (state.adminDescriptorsByEnrollment?.results || []).map((item) =>
    item?.billing_descriptor_id === updatedId
      ? {
          ...item,
          descriptor_type: payload?.descriptor_type ?? item?.descriptor_type,
        }
      : item,
  )

  return state.merge({
    adminDescriptorTypeUpdating: false,
    adminDescriptorsByEnrollment: state.adminDescriptorsByEnrollment
      ? {
          ...state.adminDescriptorsByEnrollment,
          results: nextResults,
        }
      : state.adminDescriptorsByEnrollment,
  })
}
const updateAdminDescriptorTypeFailure = (state) =>
  state.merge({adminDescriptorTypeUpdating: false})

const bulkUpdateAdminDescriptorStatusRequest = (state) => state
const bulkUpdateAdminDescriptorStatusSuccess = (state, {payload}) => {
  const updated = Array.isArray(payload) ? payload : []
  if (!updated.length || !state.adminDescriptorsByEnrollment) return state

  const updatedById = {}
  updated.forEach((item) => {
    updatedById[item?.id] = item
  })

  const nextResults = (state.adminDescriptorsByEnrollment?.results || []).map((item) => {
    const patch = updatedById[item?.billing_descriptor_id]
    if (!patch) return item

    return {
      ...item,
      current_status: patch.current_status ?? item.current_status,
      descriptor_type: patch.match_type ?? item.descriptor_type,
    }
  })

  return state.merge({
    adminDescriptorsByEnrollment: {
      ...state.adminDescriptorsByEnrollment,
      results: nextResults,
    },
  })
}
const bulkUpdateAdminDescriptorStatusFailure = (state) => state

const updateEnrollmentRequest = (state) => state.merge({ saveFetching: true })
const updateEnrollmentSuccess = (state, { payload: enrollment }) => {
  let saveResult = enrollment?.["is_active"]
    ? { enrollment_turn_on: enrollment?.name || true }
    : { enrollment_turn_off: enrollment?.name || true }

  return state.merge({
    saveFetching: false,
    saveResult,
    enrollments: [...state?.enrollments.map((el) => (el?.id === enrollment?.id ? enrollment : el))]
  })
}
const updateEnrollmentFailure = (state) => state.merge({ saveFetching: false })
const changeStatusEnrollmentRequest = (state) => state.merge({ saveFetching: true })
const changeStatusEnrollmentSuccess = (state, { payload: enrollment }) => {
  return state.merge({
    saveFetching: false,
    saveResult: "change_status",
    enrollments: [
      ...state?.enrollments?.map((el) => (el?.id === enrollment?.id ? { ...enrollment } : el))
    ]
  })
}
const changeStatusEnrollmentFailure = (state) => state.merge({ saveFetching: false })
const changeOnboardingStepRequest = (state) => state.merge({ fetching: true })
const changeOnboardingStepSuccess = (state) => state.merge({ fetching: false })
const changeOnboardingStepFailure = (state) => state.merge({ fetching: false })

const changeNextCreateAccountStep = (state, { nextCreateAccountStep }) => {
  if (!nextCreateAccountStep || nextCreateAccountStep === 1) {
    return state.merge({
      nextCreateAccountStep,
      businessAccount: null,
      paymentProcessors: [],
      enrollments: [],
      billingDescriptors: {
        descriptor_data: [],
        dont_remember_descriptors: false,
        dont_remember_arn_codes: false
      },
      checkoutSession: null
    })
  } else {
    return state.merge({ nextCreateAccountStep })
  }
}

const requestNewIntegrationRequest = (state) => state.merge({ saveFetching: true })
const requestNewIntegrationSuccess = (state) => {
  return state.merge({
    saveFetching: false,
    saveResult: "request_new_integration"
  })
}
const requestNewIntegrationFailure = (state) => state.merge({ saveFetching: false })

const declinePremiumFeaturesRequest = (state) => state.merge({ saveFetching: true })
const declinePremiumFeaturesSuccess = (state) => state.merge({ saveFetching: false })
const declinePremiumFeaturesFailure = (state) => state.merge({ saveFetching: false })

const updateUserPriceRequest = (state) => state.merge({ saveFetching: true })
const updateUserPriceSuccess = (state, { payload: updateBusinessAccount }) => {
  //let saveResult = enrollment?.['is_active'] ? ({enrollment_turn_on: enrollment?.name || true}) : ({enrollment_turn_off: enrollment?.name || true})

  return state.merge({
    saveFetching: false,
    saveResult: "update_price",
    businessAccount: { ...state.businessAccount, ...updateBusinessAccount }
  })
}
const updateUserPriceFailure = (state) => state.merge({ saveFetching: false })

const getMaxCreateStepsRequest = (state) => state.merge({ maxCreateStepsFetching: true })
const getMaxCreateStepsSuccess = (state, { payload: data }) =>
  state.merge({
    maxCreateStepsFetching: false,
    maxCreateSteps: data?.["onboarding_steps"]
  })
const getMaxCreateStepsFailure = (state) => state.merge({ maxCreateStepsFetching: false })

const getBannerInfoRequest = (state) => state.merge({ bannerInfoFetching: true })
const getBannerInfoSuccess = (state, { payload: data }) =>
  state.merge({
    bannerInfoFetching: false,
    bannerInfo: data
  })
const getBannerInfoFailure = (state) => state.merge({ bannerInfoFetching: false })

const getBusinessInfoRequest = (state) => state.merge()
const getBusinessInfoSuccess = (state, { payload: businessInfo }) =>
  state.merge({
    businessInfo
  })
const getBusinessInfoFailure = (state) => state.merge()

const trackEventRequest = (state, { payload: data }) => state.merge({ trackEventfetching: true })
const trackEventSuccess = (state, { payload: data }) => state.merge({ trackEventfetching: false })
const trackEventFailure = (state) => state.merge({ trackEventfetching: false })

export const userSetProp = (state, { key, value }) => {
  const obj = {}
  obj[key] = value
  if (key === "nextManageEnrollmentStep" && value === null) {
    obj["billingDescriptors"] = {
      descriptor_data: [],
      dont_remember_descriptors: false,
      dont_remember_arn_codes: false
    }
  }

  return state.merge(obj)
}

// CHANGE EMAIL ONBOARDING
const changeEmailOnboardingRequest = (state) =>
  state.merge({ saveFetching: true, emailChanged: false, errors: false })

const changeEmailOnboardingSuccess = (state, { payload }) =>
  state.merge({
    saveFetching: false,
    saveResult: { confirm: true },
    emailChanged: true,
    errors: false
  })

const changeEmailOnboardingFailure = (state, { payload: { errors } }) =>
  state.merge({ saveFetching: false, errors, emailChanged: false })

const setDemoTourStep = (state, { payload }) => state.merge({ demoTourStep: payload })

const checkMaverickDbaRequest = (state) =>
  state.merge({
    maverickDbaFetching: true,
    maverickDbaError: null
  })

const checkMaverickDbaSuccess = (state, { payload }) =>
  state.merge({
    maverickDbaFetching: false,
    maverickDba: payload
  })

const checkMaverickDbaFailure = (state, { payload: { errors } }) =>
  state.merge({
    maverickDbaFetching: false,
    maverickDbaError: errors
  })
const checkMaverickDbaReset = (state) =>
  state.merge({
    maverickDba: null,
    maverickDbaError: null,
    maverickDbaFetching: false
  })

const connectMaverickTerminalsRequest = (state) =>
  state.merge({
    maverickConnectFetching: true,
    maverickConnectError: null
  })

const connectMaverickTerminalsSuccess = (state, { payload }) =>
  state.merge({
    maverickConnectFetching: false,
    maverickConnect: payload,
    saveResult: "connected"
  })

const connectMaverickTerminalsFailure = (state, { payload: { errors } }) =>
  state.merge({
    maverickConnectFetching: false,
    maverickConnectError: errors
  })

const connectMaverickTerminalsReset = (state) =>
  state.merge({
    maverickConnect: null,
    maverickConnectError: null,
    maverickConnectFetching: false
  })

const demoDataToggleRequest = (state) => state.merge({ demoDataShownToggleLoading: true })
const demoDataToggleSuccess = (state) => state.merge({ demoDataShownToggleLoading: false })
const demoDataToggleFailure = (state) => state.merge({ demoDataShownToggleLoading: false })

const changeBusinessAccountRequest = (state) =>
  state.merge({
    businessAccountSwitching: true,
    businessAccount: null,
    userEnrollmentsBusinessAccountId: null,
    descriptorsByEnrollment: null,
    checkoutSession: null,
    // enrollments belong to the previous account; keep them out of the next one
    enrollments: [],
    billingDescriptors: {
      descriptor_data: [],
      dont_remember_descriptors: false,
      dont_remember_arn_codes: false
    }
  })
const changeBusinessAccountSuccess = (state, { payload }) =>
  state.merge({ businessAccountSwitching: false })
const changeBusinessAccountFailure = (state) => state.merge({ businessAccountSwitching: false })

const logout = (state) => INITIAL_STATE

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_VERIFY_LAST_REQ_TIME]: setVerifyLastReqTime,

  [Types.USER_REQUEST]: userRequest,
  [Types.USER_SUCCESS]: userSuccess,
  [Types.USER_FAILURE]: userFailure,

  [Types.GET_USER_INFO_BY_ADMIN_REQUEST]: getUserInfoByAdminRequest,
  [Types.GET_USER_INFO_BY_ADMIN_SUCCESS]: getUserInfoByAdminSuccess,
  [Types.GET_USER_INFO_BY_ADMIN_FAILURE]: getUserInfoByAdminFailure,

  [Types.USER_SAVE_REQUEST]: userSaveRequest,
  [Types.USER_SAVE_SUCCESS]: userSaveSuccess,
  [Types.USER_SAVE_FAILURE]: userSaveFailure,

  [Types.USER_SAVE_RESULT_RESET]: userSaveResultReset,
  [Types.USER_ERRORS_RESET]: userErrorsReset,

  [Types.USER_SAVE_AVATAR_REQUEST]: userSaveAvatarRequest,
  [Types.USER_SAVE_AVATAR_SUCCESS]: userSaveAvatarSuccess,
  [Types.USER_SAVE_AVATAR_FAILURE]: userSaveAvatarFailure,

  [Types.CHANGE_PASSWORD_REQUEST]: changePasswordRequest,
  [Types.CHANGE_PASSWORD_SUCCESS]: changePasswordSuccess,
  [Types.CHANGE_PASSWORD_FAILURE]: changePasswordFailure,

  [Types.SEND_CODE_PASSWORD_REQUEST]: sendCodePasswordRequest,
  [Types.SEND_CODE_PASSWORD_SUCCESS]: sendCodePasswordSuccess,
  [Types.SEND_CODE_PASSWORD_FAILURE]: sendCodePasswordFailure,

  [Types.CONFIRM_CODE_PASSWORD_REQUEST]: confirmCodePasswordRequest,
  [Types.CONFIRM_CODE_PASSWORD_SUCCESS]: confirmCodePasswordSuccess,
  [Types.CONFIRM_CODE_PASSWORD_FAILURE]: confirmCodePasswordFailure,

  [Types.CREATE_NEW_PASSWORD_REQUEST]: createNewPasswordRequest,
  [Types.CREATE_NEW_PASSWORD_SUCCESS]: createNewPasswordSuccess,
  [Types.CREATE_NEW_PASSWORD_FAILURE]: createNewPasswordFailure,

  [Types.SET_PASSWORD_REQUEST]: setPasswordRequest,
  [Types.SET_PASSWORD_SUCCESS]: setPasswordSuccess,
  [Types.SET_PASSWORD_FAILURE]: setPasswordFailure,

  [Types.CHANGE_EMAILS_REQUEST]: changeEmailsRequest,
  [Types.CHANGE_EMAILS_SUCCESS]: changeEmailsSuccess,
  [Types.CHANGE_EMAILS_FAILURE]: changeEmailsFailure,

  [Types.VERIFY_EMAIL_REQUEST]: verifyEmailRequest,
  [Types.VERIFY_EMAIL_SUCCESS]: verifyEmailSuccess,
  [Types.VERIFY_EMAIL_FAILURE]: verifyEmailFailure,

  [Types.CONFIRM_EMAILS_REQUEST]: confirmEmailsRequest,
  [Types.CONFIRM_EMAILS_SUCCESS]: confirmEmailsSuccess,
  [Types.CONFIRM_EMAILS_FAILURE]: confirmEmailsFailure,

  [Types.CHANGE_LANGUAGE_REQUEST]: changeLanguageRequest,
  [Types.CHANGE_LANGUAGE_SUCCESS]: changeLanguageSuccess,
  [Types.CHANGE_LANGUAGE_FAILURE]: changeLanguageFailure,

  [Types.SEND_ONBOARDING_FORM_REQUEST]: sendOnboardingFormRequest,
  [Types.SEND_ONBOARDING_FORM_SUCCESS]: sendOnboardingFormSuccess,
  [Types.SEND_ONBOARDING_FORM_FAILURE]: sendOnboardingFormFailure,

  [Types.CREATE_BUSINESS_ACCOUNT_REQUEST]: createBusinessAccountRequest,
  [Types.CREATE_BUSINESS_ACCOUNT_SUCCESS]: createBusinessAccountSuccess,
  [Types.CREATE_BUSINESS_ACCOUNT_FAILURE]: createBusinessAccountFailure,

  [Types.UPDATE_BUSINESS_ACCOUNT_REQUEST]: updateBusinessAccountRequest,
  [Types.UPDATE_BUSINESS_ACCOUNT_SUCCESS]: updateBusinessAccountSuccess,
  [Types.UPDATE_BUSINESS_ACCOUNT_FAILURE]: updateBusinessAccountFailure,

  [Types.GET_BUSINESS_ACCOUNT_REQUEST]: getBusinessAccountRequest,
  [Types.GET_BUSINESS_ACCOUNT_SUCCESS]: getBusinessAccountSuccess,
  [Types.GET_BUSINESS_ACCOUNT_FAILURE]: getBusinessAccountFailure,

  [Types.GET_AUTO_REFUND_LOGS_REQUEST]: getAutoRefundLogsRequest,
  [Types.GET_AUTO_REFUND_LOGS_SUCCESS]: getAutoRefundLogsSuccess,
  [Types.GET_AUTO_REFUND_LOGS_FAILURE]: getAutoRefundLogsFailure,
  [Types.GET_INTEGRATION_LOGS_REQUEST]: getIntegrationLogsRequest,
  [Types.GET_INTEGRATION_LOGS_SUCCESS]: getIntegrationLogsSuccess,
  [Types.GET_INTEGRATION_LOGS_FAILURE]: getIntegrationLogsFailure,

  [Types.GET_BUSINESS_ACCOUNTS_REQUEST]: getBusinessAccountsRequest,
  [Types.GET_BUSINESS_ACCOUNTS_SUCCESS]: getBusinessAccountsSuccess,
  [Types.GET_BUSINESS_ACCOUNTS_FAILURE]: getBusinessAccountsFailure,

  [Types.GET_BUSINESS_ACCOUNTS_SETTINGS_REQUEST]: getBusinessAccountsSettingsRequest,
  [Types.GET_BUSINESS_ACCOUNTS_SETTINGS_SUCCESS]: getBusinessAccountsSettingsSuccess,
  [Types.GET_BUSINESS_ACCOUNTS_SETTINGS_FAILURE]: getBusinessAccountsSettingsFailure,

  [Types.GET_BUSINESS_ACCOUNTS_WITH_ROLE_REQUEST]: getBusinessAccountsWithRoleRequest,
  [Types.GET_BUSINESS_ACCOUNTS_WITH_ROLE_SUCCESS]: getBusinessAccountsWithRoleSuccess,
  [Types.GET_BUSINESS_ACCOUNTS_WITH_ROLE_FAILURE]: getBusinessAccountsWithRoleFailure,

  [Types.DELETE_BUSINESS_ACCOUNT_REQUEST]: deleteBusinessAccountRequest,
  [Types.DELETE_BUSINESS_ACCOUNT_SUCCESS]: deleteBusinessAccountSuccess,
  [Types.DELETE_BUSINESS_ACCOUNT_FAILURE]: deleteBusinessAccountFailure,

  [Types.SKIP_PAYMENT_CONNECT_REQUEST]: skipPaymentConnectRequest,
  [Types.SKIP_PAYMENT_CONNECT_SUCCESS]: skipPaymentConnectSuccess,
  [Types.SKIP_PAYMENT_CONNECT_FAILURE]: skipPaymentConnectFailure,

  [Types.GET_PAYMENT_PROCESSORS_REQUEST]: getPaymentProcessorsRequest,
  [Types.GET_PAYMENT_PROCESSORS_SUCCESS]: getPaymentProcessorsSuccess,
  [Types.GET_PAYMENT_PROCESSORS_FAILURE]: getPaymentProcessorsFailure,

  [Types.CONNECT_PAYMENT_PROCESSOR_REQUEST]: connectPaymentProcessorRequest,
  [Types.CONNECT_PAYMENT_PROCESSOR_SUCCESS]: connectPaymentProcessorSuccess,
  [Types.CONNECT_PAYMENT_PROCESSOR_FAILURE]: connectPaymentProcessorFailure,

  [Types.DISCONNECT_PAYMENT_PROCESSOR_REQUEST]: disconnectPaymentProcessorRequest,
  [Types.DISCONNECT_PAYMENT_PROCESSOR_SUCCESS]: disconnectPaymentProcessorSuccess,
  [Types.DISCONNECT_PAYMENT_PROCESSOR_FAILURE]: disconnectPaymentProcessorFailure,

  [Types.DISCONNECT_PAYMENT_PROCESSOR_EXTERNALLY_REQUEST]:
    disconnectPaymentProcessorExternallyRequest,
  [Types.DISCONNECT_PAYMENT_PROCESSOR_EXTERNALLY_SUCCESS]:
    disconnectPaymentProcessorExternallySuccess,
  [Types.DISCONNECT_PAYMENT_PROCESSOR_EXTERNALLY_FAILURE]:
    disconnectPaymentProcessorExternallyFailure,

  [Types.ADYEN_UPLOAD_FILES_REQUEST]: adyenUploadFilesRequest,
  [Types.ADYEN_UPLOAD_FILES_SUCCESS]: adyenUploadFilesSuccess,
  [Types.ADYEN_UPLOAD_FILES_FAILURE]: adyenUploadFilesFailure,

  [Types.CREATE_BILLING_DESCRIPTOR_REQUEST]: createBillingDescriptorRequest,
  [Types.CREATE_BILLING_DESCRIPTOR_SUCCESS]: createBillingDescriptorSuccess,
  [Types.CREATE_BILLING_DESCRIPTOR_FAILURE]: createBillingDescriptorFailure,

  [Types.VALIDATE_BILLING_DESCRIPTOR_REQUEST]: validateBillingDescriptorRequest,
  [Types.VALIDATE_BILLING_DESCRIPTOR_SUCCESS]: validateBillingDescriptorSuccess,
  [Types.VALIDATE_BILLING_DESCRIPTOR_FAILURE]: validateBillingDescriptorFailure,
  [Types.VALIDATE_BILLING_DESCRIPTOR_RESET]: validateBillingDescriptorReset,

  [Types.UPDATE_BILLING_DESCRIPTOR_STATUS_REQUEST]: updateBillingDescriptorStatusRequest,
  [Types.UPDATE_BILLING_DESCRIPTOR_STATUS_SUCCESS]: updateBillingDescriptorStatusSuccess,
  [Types.UPDATE_BILLING_DESCRIPTOR_STATUS_FAILURE]: updateBillingDescriptorStatusFailure,

  [Types.GET_BILLING_DESCRIPTORS_REQUEST]: getBillingDescriptorsRequest,
  [Types.GET_BILLING_DESCRIPTORS_SUCCESS]: getBillingDescriptorsSuccess,
  [Types.GET_BILLING_DESCRIPTORS_FAILURE]: getBillingDescriptorsFailure,

  [Types.GET_USERS_CARDS_REQUEST]: getUsersCardsRequest,
  [Types.GET_USERS_CARDS_SUCCESS]: getUsersCardsSuccess,
  [Types.GET_USERS_CARDS_FAILURE]: getUsersCardsFailure,

  [Types.DELETE_USER_CARD_REQUEST]: deleteUserCardRequest,
  [Types.DELETE_USER_CARD_SUCCESS]: deleteUserCardSuccess,
  [Types.DELETE_USER_CARD_FAILURE]: deleteUserCardFailure,

  [Types.UPDATE_DEFAULT_CARD_REQUEST]: updateDefaultCardRequest,
  [Types.UPDATE_DEFAULT_CARD_SUCCESS]: updateDefaultCardSuccess,
  [Types.UPDATE_DEFAULT_CARD_FAILURE]: updateDefaultCardFailure,

  [Types.CREATE_CHECKOUT_SESSION_REQUEST]: createCheckoutSessionRequest,
  [Types.CREATE_CHECKOUT_SESSION_SUCCESS]: createCheckoutSessionSuccess,
  [Types.CREATE_CHECKOUT_SESSION_FAILURE]: createCheckoutSessionFailure,

  [Types.ATTACH_PAYMENT_REQUEST]: attachPaymentRequest,
  [Types.ATTACH_PAYMENT_SUCCESS]: attachPaymentSuccess,
  [Types.ATTACH_PAYMENT_FAILURE]: attachPaymentFailure,

  [Types.GET_PREMIUM_FEATURES_REQUEST]: getPremiumFeaturesRequest,
  [Types.GET_PREMIUM_FEATURES_SUCCESS]: getPremiumFeaturesSuccess,
  [Types.GET_PREMIUM_FEATURES_FAILURE]: getPremiumFeaturesFailure,

  [Types.GET_ENROLLMENTS_REQUEST]: getEnrollmentsRequest,
  [Types.GET_ENROLLMENTS_SUCCESS]: getEnrollmentsSuccess,
  [Types.GET_ENROLLMENTS_FAILURE]: getEnrollmentsFailure,

  [Types.GET_ADMIN_ENROLLMENTS_REQUEST]: getAdminEnrollmentsRequest,
  [Types.GET_ADMIN_ENROLLMENTS_SUCCESS]: getAdminEnrollmentsSuccess,
  [Types.GET_ADMIN_ENROLLMENTS_FAILURE]: getAdminEnrollmentsFailure,

  [Types.GET_ENROLLMENTS_WITHOUT_DESCRIPTORS_REQUEST]: getEnrollmentsWithoutDescriptorsRequest,
  [Types.GET_ENROLLMENTS_WITHOUT_DESCRIPTORS_SUCCESS]: getEnrollmentsWithoutDescriptorsSuccess,
  [Types.GET_ENROLLMENTS_WITHOUT_DESCRIPTORS_FAILURE]: getEnrollmentsWithoutDescriptorsFailure,

  [Types.GET_DESCRIPTORS_BY_ENROLLMENT_REQUEST]: getDescriptorsByEnrollmentRequest,
  [Types.GET_DESCRIPTORS_BY_ENROLLMENT_SUCCESS]: getDescriptorsByEnrollmentSuccess,
  [Types.GET_DESCRIPTORS_BY_ENROLLMENT_FAILURE]: getDescriptorsByEnrollmentFailure,

  [Types.GET_MORE_DESCRIPTORS_BY_ENROLLMENT_REQUEST]: getMoreDescriptorsByEnrollmentRequest,
  [Types.GET_MORE_DESCRIPTORS_BY_ENROLLMENT_SUCCESS]: getMoreDescriptorsByEnrollmentSuccess,
  [Types.GET_MORE_DESCRIPTORS_BY_ENROLLMENT_FAILURE]: getMoreDescriptorsByEnrollmentFailure,

  [Types.GET_VISA_CODES_BY_ENROLLMENT_REQUEST]: getVisaCodesByEnrollmentRequest,
  [Types.GET_VISA_CODES_BY_ENROLLMENT_SUCCESS]: getVisaCodesByEnrollmentSuccess,
  [Types.GET_VISA_CODES_BY_ENROLLMENT_FAILURE]: getVisaCodesByEnrollmentFailure,

  [Types.GET_MORE_VISA_CODES_BY_ENROLLMENT_REQUEST]: getMoreVisaCodesByEnrollmentRequest,
  [Types.GET_MORE_VISA_CODES_BY_ENROLLMENT_SUCCESS]: getMoreVisaCodesByEnrollmentSuccess,
  [Types.GET_MORE_VISA_CODES_BY_ENROLLMENT_FAILURE]: getMoreVisaCodesByEnrollmentFailure,
  [Types.GET_ADMIN_DESCRIPTORS_BY_ENROLLMENT_REQUEST]: getAdminDescriptorsByEnrollmentRequest,
  [Types.GET_ADMIN_DESCRIPTORS_BY_ENROLLMENT_SUCCESS]: getAdminDescriptorsByEnrollmentSuccess,
  [Types.GET_ADMIN_DESCRIPTORS_BY_ENROLLMENT_FAILURE]: getAdminDescriptorsByEnrollmentFailure,

  [Types.GET_MORE_ADMIN_DESCRIPTORS_BY_ENROLLMENT_REQUEST]: getMoreAdminDescriptorsByEnrollmentRequest,
  [Types.GET_MORE_ADMIN_DESCRIPTORS_BY_ENROLLMENT_SUCCESS]: getMoreAdminDescriptorsByEnrollmentSuccess,
  [Types.GET_MORE_ADMIN_DESCRIPTORS_BY_ENROLLMENT_FAILURE]: getMoreAdminDescriptorsByEnrollmentFailure,

  [Types.UPDATE_ADMIN_DESCRIPTOR_STATUS_REQUEST]: updateAdminDescriptorStatusRequest,
  [Types.UPDATE_ADMIN_DESCRIPTOR_STATUS_SUCCESS]: updateAdminDescriptorStatusSuccess,
  [Types.UPDATE_ADMIN_DESCRIPTOR_STATUS_FAILURE]: updateAdminDescriptorStatusFailure,

  [Types.UPDATE_ADMIN_DESCRIPTOR_TYPE_REQUEST]: updateAdminDescriptorTypeRequest,
  [Types.UPDATE_ADMIN_DESCRIPTOR_TYPE_SUCCESS]: updateAdminDescriptorTypeSuccess,
  [Types.UPDATE_ADMIN_DESCRIPTOR_TYPE_FAILURE]: updateAdminDescriptorTypeFailure,

  [Types.BULK_UPDATE_ADMIN_DESCRIPTOR_STATUS_REQUEST]: bulkUpdateAdminDescriptorStatusRequest,
  [Types.BULK_UPDATE_ADMIN_DESCRIPTOR_STATUS_SUCCESS]: bulkUpdateAdminDescriptorStatusSuccess,
  [Types.BULK_UPDATE_ADMIN_DESCRIPTOR_STATUS_FAILURE]: bulkUpdateAdminDescriptorStatusFailure,

  [Types.UPDATE_ENROLLMENT_REQUEST]: updateEnrollmentRequest,
  [Types.UPDATE_ENROLLMENT_SUCCESS]: updateEnrollmentSuccess,
  [Types.UPDATE_ENROLLMENT_FAILURE]: updateEnrollmentFailure,

  [Types.CHANGE_STATUS_ENROLLMENT_REQUEST]: changeStatusEnrollmentRequest,
  [Types.CHANGE_STATUS_ENROLLMENT_SUCCESS]: changeStatusEnrollmentSuccess,
  [Types.CHANGE_STATUS_ENROLLMENT_FAILURE]: changeStatusEnrollmentFailure,

  [Types.CHANGE_ONBOARDING_STEP_REQUEST]: changeOnboardingStepRequest,
  [Types.CHANGE_ONBOARDING_STEP_SUCCESS]: changeOnboardingStepSuccess,
  [Types.CHANGE_ONBOARDING_STEP_FAILURE]: changeOnboardingStepFailure,

  [Types.REQUEST_NEW_INTEGRATION_REQUEST]: requestNewIntegrationRequest,
  [Types.REQUEST_NEW_INTEGRATION_SUCCESS]: requestNewIntegrationSuccess,
  [Types.REQUEST_NEW_INTEGRATION_FAILURE]: requestNewIntegrationFailure,

  [Types.DECLINE_PREMIUM_FEATURES_REQUEST]: declinePremiumFeaturesRequest,
  [Types.DECLINE_PREMIUM_FEATURES_SUCCESS]: declinePremiumFeaturesSuccess,
  [Types.DECLINE_PREMIUM_FEATURES_FAILURE]: declinePremiumFeaturesFailure,

  [Types.UPDATE_USER_PRICE_REQUEST]: updateUserPriceRequest,
  [Types.UPDATE_USER_PRICE_SUCCESS]: updateUserPriceSuccess,
  [Types.UPDATE_USER_PRICE_FAILURE]: updateUserPriceFailure,

  [Types.GET_MAX_CREATE_STEPS_REQUEST]: getMaxCreateStepsRequest,
  [Types.GET_MAX_CREATE_STEPS_SUCCESS]: getMaxCreateStepsSuccess,
  [Types.GET_MAX_CREATE_STEPS_FAILURE]: getMaxCreateStepsFailure,

  [Types.GET_BANNER_INFO_REQUEST]: getBannerInfoRequest,
  [Types.GET_BANNER_INFO_SUCCESS]: getBannerInfoSuccess,
  [Types.GET_BANNER_INFO_FAILURE]: getBannerInfoFailure,

  [Types.GET_BUSINESS_INFO_REQUEST]: getBusinessInfoRequest,
  [Types.GET_BUSINESS_INFO_SUCCESS]: getBusinessInfoSuccess,
  [Types.GET_BUSINESS_INFO_FAILURE]: getBusinessInfoFailure,

  [Types.TRACK_EVENT_REQUEST]: trackEventRequest,
  [Types.TRACK_EVENT_SUCCESS]: trackEventSuccess,
  [Types.TRACK_EVENT_FAILURE]: trackEventFailure,

  [Types.CHANGE_EMAIL_ONBOARDING_REQUEST]: changeEmailOnboardingRequest,
  [Types.CHANGE_EMAIL_ONBOARDING_SUCCESS]: changeEmailOnboardingSuccess,
  [Types.CHANGE_EMAIL_ONBOARDING_FAILURE]: changeEmailOnboardingFailure,

  [Types.CHANGE_NEXT_CREATE_ACCOUNT_STEP]: changeNextCreateAccountStep,

  [Types.USER_SET_PROP]: userSetProp,

  [Types.SET_DEMO_TOUR_STEP]: setDemoTourStep,

  [Types.CHECK_MAVERICK_DBA_REQUEST]: checkMaverickDbaRequest,
  [Types.CHECK_MAVERICK_DBA_SUCCESS]: checkMaverickDbaSuccess,
  [Types.CHECK_MAVERICK_DBA_FAILURE]: checkMaverickDbaFailure,
  [Types.CHECK_MAVERICK_DBA_RESET]: checkMaverickDbaReset,

  [Types.CONNECT_MAVERICK_TERMINALS_REQUEST]: connectMaverickTerminalsRequest,
  [Types.CONNECT_MAVERICK_TERMINALS_SUCCESS]: connectMaverickTerminalsSuccess,
  [Types.CONNECT_MAVERICK_TERMINALS_FAILURE]: connectMaverickTerminalsFailure,
  [Types.CONNECT_MAVERICK_TERMINALS_RESET]: connectMaverickTerminalsReset,

  [Types.DEMO_DATA_TOGGLE_REQUEST]: demoDataToggleRequest,
  [Types.DEMO_DATA_TOGGLE_SUCCESS]: demoDataToggleSuccess,
  [Types.DEMO_DATA_TOGGLE_FAILURE]: demoDataToggleFailure,

  [Types.CHANGE_BUSINESS_ACCOUNT_REQUEST]: changeBusinessAccountRequest,
  [Types.CHANGE_BUSINESS_ACCOUNT_SUCCESS]: changeBusinessAccountSuccess,
  [Types.CHANGE_BUSINESS_ACCOUNT_FAILURE]: changeBusinessAccountFailure,

  [Types.LOGOUT]: logout
})
